import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
} from '@/components/ui/sheet'
import { useTranslation } from 'react-i18next'
import { CheckoutLivePreview } from './CheckoutLivePreview'
import { CheckoutTemplateId } from '@/utils/checkoutTemplates'

type CheckoutPreviewPaneProps = {
  checkoutId: string
  checkoutBaseUrl?: string
  template?: CheckoutTemplateId
  reloadToken: number
  wide: boolean
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function CheckoutPreviewPane({
  checkoutId,
  checkoutBaseUrl,
  template,
  reloadToken,
  wide,
  open,
  onOpenChange,
}: CheckoutPreviewPaneProps) {
  const { t } = useTranslation(['checkouts'])

  return (
    <>
      {wide ? (
        <aside className="hidden h-full min-h-0 w-full min-w-0 xl:block">
          <CheckoutLivePreview
            checkoutId={checkoutId}
            checkoutBaseUrl={checkoutBaseUrl}
            template={template}
            reloadToken={reloadToken}
            className="h-full max-h-full"
          />
        </aside>
      ) : (
        <Sheet open={open} onOpenChange={onOpenChange}>
          <SheetContent
            side="bottom"
            className="h-[92dvh] overflow-y-auto border-colorBorder bg-black p-4 motion-reduce:animate-none motion-reduce:transition-none"
          >
            <SheetTitle className="sr-only">
              {t('checkouts:preview_title')}
            </SheetTitle>
            <SheetDescription className="sr-only">
              {t('checkouts:preview_caption')}
            </SheetDescription>
            <CheckoutLivePreview
              checkoutId={checkoutId}
              checkoutBaseUrl={checkoutBaseUrl}
              template={template}
              reloadToken={reloadToken}
              className="h-[min(40rem,calc(92dvh-3rem))] max-h-[calc(92dvh-3rem)]"
            />
          </SheetContent>
        </Sheet>
      )}
    </>
  )
}
